<div class="form-group">
    <label class="input-label">Person is older than:</label>
    <input class="form-control"
           name="minRows"
           type="number"
           value="{{fieldOptions.validate.olderThan}}"
           [(ngModel)]="fieldOptions.validate.olderThan">
</div>